<script>
import { mixin as clickaway } from 'vue-clickaway';

export default {

  mixins: [clickaway],

  props: {
    items: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      open: false,
      currentItem: undefined,
    };
  },

  computed: {
    selected() {
      return !this.currentItem ? this.items[0] : this.currentItem;
    },
  },

  methods: {
    select(item) {
      this.currentItem = item;
      this.open = false;

      this.$emit('selected', item);
    },
    close() {
      this.open = false;
    },
  },
};
</script>

<template lang="pug">
.relative.inline-block.text-left(v-on-clickaway="close")
  div
    span.rounded-md.shadow-sm
      button#options-menu.inline-flex.justify-center.w-full.rounded-md.border.border-gray-300.px-3.py-2.bg-white.text-sm.leading-4.font-medium.text-gray-700.transition.ease-in-out.duration-150(type='button' class='hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-gray-50 active:text-gray-800' aria-haspopup='true' aria-expanded='true' @click="open = !open")
        | {{ $t(selected) }}
        svg.-mr-1.ml-2.h-4.w-5(viewbox='0 0 20 20' fill='currentColor')
          path(fill-rule='evenodd' d='M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z' clip-rule='evenodd')
  //
    Dropdown panel, show/hide based on dropdown state.
    Entering: "transition ease-out duration-100"
    From: "transform opacity-0 scale-95"
    To: "transform opacity-100 scale-100"
    Leaving: "transition ease-in duration-75"
    From: "transform opacity-100 scale-100"
    To: "transform opacity-0 scale-95"
  .origin-top-right.absolute.left-0.mt-2.w-56.rounded-md.shadow-lg(v-if="open")
    .rounded-md.bg-white.shadow-xs
      .py-1(role='menu' aria-orientation='vertical' aria-labelledby='options-menu')
        template(v-for="item in items")
          dropdown-item(:title="item", @clicked="select(item)")

</template>
